export const OFFICINA_CATEGORIES = [
    {
        key: "sollevamento",
        title: "Sollevamento",
        desc: "Ponti a 2 e 4 colonne, a forbice, colonne mobili wireless e sollevatori per mezzi pesanti.",
        img: "/officina/ponte.png",
        brand: "Ravaglioli",
    },
    {
        key: "smontagomme",
        title: "Smontagomme",
        desc: "Smontagomme automatici e superautomatici per auto, moto, camion e autobus.",
        img: "/officina/smontagomme.png",
        brand: "Ravaglioli",
    },
    {
        key: "equilibratrici",
        title: "Equilibratrici",
        desc: "Equilibratrici touchscreen con rilevamento automatico per gommisti e officine.",
        img: "/officina/equilibratrice.png",
        brand: "Ravaglioli",
    },
    {
        key: "assetto",
        title: "Assetto ruote 3D",
        desc: "Sistemi di allineamento 3D a parete e a torre per concessionarie e centri gomme.",
        img: "/officina/assetto.png",
        brand: "Ravaglioli",
    },
    {
        key: "revisione",
        title: "Linee revisione",
        desc: "Banchi prova freni, provagiochi e linee di diagnosi certificate per centri revisione.",
        img: "/officina/revisione.png",
        brand: "Ravaglioli",
        wide: true,
    },
    {
        key: "utensileria",
        title: "Utensileria e arredo officina",
        desc: "Carrelli, utensili professionali e arredo tecnico modulare per l'officina organizzata.",
        img: "/brands/beta-arredo.jpg",
        photo: true,
    },
    {
        key: "aspirazione",
        title: "Aspirazione gas, olio e aria",
        desc: "Aspirazione gas di scarico, gestione computerizzata olio nuovo ed esausto, impianti aria compressa.",
        img: "/brands/filcar-aspirazione.jpg",
        photo: true,
    },
    {
        key: "idropulitrici",
        title: "Idropulitrici professionali",
        desc: "Idropulitrici ad acqua fredda e calda per officine, concessionarie e piazzali.",
        img: "/brands/comet-idropulitrici.jpg",
        photo: true,
    },
];
